import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { DisplayMode } from '@r-core';

export const addApplianceMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Add Appliance',
		isVisible: ({ controller: { navigation, readonly }}): boolean => {
			return !readonly && navigation.displayMode !== DisplayMode.Overhead;
		},
		onClick: ({ context, position, controller }): void => {
			console.log('menuitem:add-appliance:handler', context, position)
			controller.publishRequestedAction('add_appliance', context.id, {
				position
			});
		}
	};
};
